import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import invoiceListSaga from "./invoices/saga"
import campaignsListSaga from "./campaigns/list/saga"
import userSaga from "./user/saga"
import mediaBuyersBudgetsSaga from "./mediabuyers/mediabuyerbudget/saga"
import mediaBuyersPlansSaga from "./mediabuyers/mediabuyerplans/saga"
import campaignFormatListSaga from "./campaigns/formats/saga"
import appSaga from "./apps/saga"
import usersListSaga from "./user/user-list/saga"
import campaignInfoSaga from "./campaigns/campaign-info/saga"
import campaignStatusesSaga from "./campaigns/statuses/saga"
import PositionsSaga from "./positions/saga"
import PaymentFormulasSaga from "./payment-formula/saga"
import offersSaga from "./offers/saga"
import eventsSaga from "./events/saga"
import campaignSourcesListSaga from "./campaigns/sources/saga"
import campaignDirectionTypeListSaga from "./campaigns/direction-types/saga"
import campaignDeviceTypeListSaga from "./campaigns/device-types/saga"
import campaignOfferTypeListSaga from "./campaigns/offer-types/saga"
import campaignCustomNamesListSaga from "./campaigns/custom-names/saga"
import CampaignMediaBuyerListSaga from "./campaigns/media-buyers/saga"
import clientsSaga from "./clients/saga"
import campaignAdvertisingAccountListSaga from "./campaigns/advertising-accounts/saga"
import metaSaga from "./meta/saga"
import campaignCashbackListSaga from "./campaigns/cashbacks/saga"
import contractorListSaga from "./contractors/saga"
import integrationListSaga from "./integration/saga"
import reportingSaga from "./reporting/saga"
import mapperSaga from "./mapper/saga"
import legalEntityListSaga from "./legal-entity/saga"
import planListSaga from "./plans/saga"
import CohortReportListSaga from "./cohort-reports/saga"
import SalaryBonusesSaga from "./salary-bonuses/saga"
import invoiceTemplatesSaga from "./invoice_templates/saga"
import bankDetailsSaga from "./bank-details/saga"
import bankCorespondentsSaga from "./bank-corespondents/saga"
import bankUploadingSaga from "./bank-uploading/saga"
import transactionsSaga from "./transactions/saga"
import notificationsSaga from "./notifications/saga"
import warehouseSaga from "./warehouse/saga"
import userActionsSaga from "./user-actions/saga"
import userPayoutConditionsSaga from "./user-payout-conditions/saga"
import userSalaryConditionsSaga from "./user-salary-conditions/saga"
import serviceProvidersSaga from "./service-provider/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    // fork(ecommerceSaga),
    // fork(calendarSaga),
    // fork(chatSaga),
    // fork(mailsSaga),
    // fork(cryptoSaga),
    // fork(invoiceSaga),
    // fork(projectsSaga),
    // fork(tasksSaga),
    // fork(contactsSaga),
    // fork(dashboardSaga),
    // fork(dashboardSaasSaga),
    fork(notificationsSaga),
    fork(PaymentFormulasSaga),
    fork(PositionsSaga),
    fork(campaignsListSaga),
    fork(mediaBuyersBudgetsSaga),
    fork(mediaBuyersPlansSaga),
    fork(userSaga),
    fork(usersListSaga),
    fork(clientsSaga),
    fork(appSaga),
    fork(campaignFormatListSaga),
    fork(campaignInfoSaga),
    fork(campaignStatusesSaga),
    fork(offersSaga),
    fork(eventsSaga),
    fork(campaignSourcesListSaga),
    fork(campaignDirectionTypeListSaga),
    fork(campaignDeviceTypeListSaga),
    fork(campaignOfferTypeListSaga),
    fork(campaignCustomNamesListSaga),
    fork(CampaignMediaBuyerListSaga),
    fork(invoiceListSaga),
    fork(campaignAdvertisingAccountListSaga),
    fork(metaSaga),
    fork(campaignCashbackListSaga),
    fork(reportingSaga),
    fork(contractorListSaga),
    fork(integrationListSaga),
    fork(mapperSaga),
    fork(legalEntityListSaga),
    fork(planListSaga),
    fork(CohortReportListSaga),
    fork(SalaryBonusesSaga),
    fork(invoiceTemplatesSaga),
    fork(bankDetailsSaga),
    fork(bankCorespondentsSaga),
    fork(bankUploadingSaga),
    fork(transactionsSaga),
    fork(warehouseSaga),
    fork(userActionsSaga),
    fork(userPayoutConditionsSaga),
    fork(userSalaryConditionsSaga),
    fork(serviceProvidersSaga)
  ]);
}
